module.exports = __webpack_public_path__ + "images/19132-EXT1-Cam04-5236d242425a77415d8c4d96b44e9cdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_1/19132-EXT1-Cam04.jpg
// module id = 745
// module chunks = 0